import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { Loader } from 'components/loader';
import { useGoogleAuth } from 'services/hooks/use-google-auth';

import {
  CommonStylesAuthPages as CommonStyled,
  LogoHeader,
} from 'styles/components/login-pages';

const handledGoogleAuthReturns = new Set<string>();

export const GoogleAuthCallback = () => {
  const { search } = useLocation();
  const { handleGoogleAuthReturn } = useGoogleAuth();

  const handleReturnRef = useRef(handleGoogleAuthReturn);

  handleReturnRef.current = handleGoogleAuthReturn;

  useEffect(() => {
    const handleKey = search || 'empty';

    if (handledGoogleAuthReturns.has(handleKey)) {
      return;
    }

    handledGoogleAuthReturns.add(handleKey);
    void handleReturnRef.current(search);
  }, [search]);

  return (
    <CommonStyled.Section>
      <LogoHeader />

      <CommonStyled.WrapContent>
        <Loader />
      </CommonStyled.WrapContent>
    </CommonStyled.Section>
  );
};
